"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = void 0;
const axios_1 = __importDefault(require("axios"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const NetworkHelper_1 = require("./NetworkHelper");
const Tools_1 = require("./Tools");
var Network;
(function (Network) {
    /**
     * 专门用于CDN数据请求
     */
    function getCDN(url) {
        const header = {
            "Cache-Control": "max-age=0",
            "Content-Type": "application/json;charset=UTF-8",
        };
        return (0, rxjs_1.from)(axios_1.default.get(url, { headers: header })).pipe((0, operators_1.map)((response) => response.data));
    }
    Network.getCDN = getCDN;
    function get(params) {
        const { url, data, headers, authType, needBearer = true, needCommonParams = true, needProcessResp = true } = params;
        return (0, NetworkHelper_1.ProcessHeaderWithAuthType)(headers, authType, needBearer).pipe((0, operators_1.mergeMap)((newHeader) => {
            const requestOb = (0, Tools_1.createGetRequestObservableV2)(url, newHeader, data, undefined, needCommonParams);
            return (0, NetworkHelper_1.ProcessRequestObForResp)(requestOb, needProcessResp);
        }));
    }
    Network.get = get;
    function post(params) {
        const { url, data, headers, authType, needBearer = true, needCommonParams = true, needProcessResp = true } = params;
        return (0, NetworkHelper_1.ProcessHeaderWithAuthType)(headers, authType, needBearer).pipe((0, operators_1.mergeMap)((newHeader) => {
            const requestOb = (0, Tools_1.createPostRequestObservable)(url, newHeader, data, undefined, needCommonParams);
            return (0, NetworkHelper_1.ProcessRequestObForResp)(requestOb, needProcessResp);
        }));
    }
    Network.post = post;
    function put(params) {
        const { url, data, headers, authType, needBearer = true, needCommonParams = true, needProcessResp = true } = params;
        return (0, NetworkHelper_1.ProcessHeaderWithAuthType)(headers, authType, needBearer).pipe((0, operators_1.mergeMap)((newHeader) => {
            const requestOb = (0, Tools_1.createPutRequestObservable)(url, newHeader, data, undefined, needCommonParams);
            return (0, NetworkHelper_1.ProcessRequestObForResp)(requestOb, needProcessResp);
        }));
    }
    Network.put = put;
    function delete$(params) {
        const { url, data, headers, authType, needBearer = true, needCommonParams = true, needProcessResp = true } = params;
        return (0, NetworkHelper_1.ProcessHeaderWithAuthType)(headers, authType, needBearer).pipe((0, operators_1.mergeMap)((newHeader) => {
            const requestOb = (0, Tools_1.createDeleteRequestObservableV2)(url, newHeader, data, undefined, needCommonParams);
            return (0, NetworkHelper_1.ProcessRequestObForResp)(requestOb, needProcessResp);
        }));
    }
    Network.delete$ = delete$;
})(Network || (exports.Network = Network = {}));
